import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import RaceList from "../common/RaceList";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            selectedRaces: [],
            resultCountry: false,
            resultRegion: false,
            resultGroup: false,
            resultSection: props.auth.currentRole !== UserRoles.MAIN_ADMIN.id,
            resultRange: false,
            allCalculated: true,
            resultSize: '',
            onlyJuniorsBeginners: false,
            showPricesAndClasses: true,
            onlySex: '',
            onlyYear: '',
            sectionsOrGroups: '',
        });
    }

    fields = [];
    render() {
        return <div className="race-results">
            <div className="race-list">
                <RaceList selectedRaces={this.state.selectedRaces} updateSelection={this.updateRaceSelection}/>
            </div>
            <div className="report-options">
                <div className="option-group">
                    <div className="result-size">
                        <span className="option"><input id="allCalculated" name="allCalculated" type="checkbox" checked={this.state.allCalculated} onChange={this.onCheckFieldChange}/><label htmlFor="allCalculated"> Alle beregnede</label></span>
                        <span className="option">
                            <label htmlFor="resultSize">Antal eller procent (afslut med %) duer </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                              name="resultSize" id="resultSize" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]+%?"}]} value={this.state.resultSize}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                            />
                        </span>
                        <span className="option"><input id="onlyJuniorsBeginners" name="onlyJuniorsBeginners" type="checkbox" checked={this.state.onlyJuniorsBeginners} onChange={this.onCheckFieldChange}/><label htmlFor="onlyJuniorsBeginners"> Kun juniorer/begyndere</label></span>
                        <span className="option"><input id="showPricesAndClasses" name="showPricesAndClasses" type="checkbox" checked={this.state.showPricesAndClasses} onChange={this.onCheckFieldChange}/><label htmlFor="showPricesAndClasses"> Vis præmier/klasser</label></span>
                    </div>
                </div>
                <div className="option-group">
                    <div className="result-criterias">
                        <span className="option">
                            <label htmlFor="onlySex">Kun køn </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="onlySex" id="onlySex" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[AUX]"}]} value={this.state.onlySex}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onUpperCaseFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                            />
                        </span>
                        <span className="option">
                            <label htmlFor="onlyYear">Kun årgang </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="onlyYear" id="onlyYear" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.onlyYear}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[2] = instance; }}
                            />
                        </span>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <span className="option">
                            <label htmlFor="sectionsOrGroups">Sektion/Gruppe </label>
                            <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field150" containerClassName="display-inline-block"
                                              name="sectionsOrGroups" id="sectionsOrGroups" value={this.state.sectionsOrGroups}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[3] = instance; }}
                            />
                        </span> : null}
                    </div>
                </div>
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className="option-group">
                    <label>Opstillinger</label>
                    <div className="result-groupings">
                        <span className="option"><input id="resultCountry" name="resultCountry" type="checkbox" checked={this.state.resultCountry} onChange={this.onCheckFieldChange}/><label htmlFor="resultCountry"> Land</label></span>
                        <span className="option"><input id="resultRegion" name="resultRegion" type="checkbox" checked={this.state.resultRegion} onChange={this.onCheckFieldChange}/><label htmlFor="resultRegion"> Region</label></span>
                        <span className="option"><input id="resultGroup" name="resultGroup" type="checkbox" checked={this.state.resultGroup} onChange={this.onCheckFieldChange}/><label htmlFor="resultGroup"> Gruppe</label></span>
                        <span className="option"><input id="resultSection" name="resultSection" type="checkbox" checked={this.state.resultSection} onChange={this.onCheckFieldChange}/><label htmlFor="resultSection"> Sektion</label></span>
                        <span className="option"><input id="resultRange" name="resultRange" type="checkbox" checked={this.state.resultRange} onChange={this.onCheckFieldChange}/><label htmlFor="resultRange"> Område</label></span>
                    </div>
                </div> : null}
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onUpperCaseFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value.toUpperCase()});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked ? true : false});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    updateRaceSelection = (races, add = true) => {
        this.setState({
            selectedRaces: add ? this.state.selectedRaces.concat(races.filter(race => this.state.selectedRaces.indexOf(race) < 0)) : this.state.selectedRaces.filter(race => races.indexOf(race) < 0)
        })
    };

    getReportOptions = (options) => {
        const errors = [];
        let isValid = true;
        if (typeof(options) === 'undefined' || typeof(options.checkOnlyRaceSelection) === 'undefined' || options.checkOnlyRaceSelection !== true) {
            isValid = this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                this.fields.forEach((field) => {
                    field.setState({visited: true});
                });
            }
        }
        if (this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
        if ((typeof(options) === 'undefined' || typeof(options.checkOnlyRaceSelection) === 'undefined' || options.checkOnlyRaceSelection !== true) &&
            (typeof(options) === 'undefined' || typeof(options.checkResultsSelection) === 'undefined' || options.checkResultsSelection !== false) &&
            (!this.state.resultCountry && !this.state.resultRegion && !this.state.resultGroup && !this.state.resultSection && !this.state.resultRange)) errors.push('Der er ikke valgt nogen opstilling(er).');
        return {
            errors: errors,
            isErrors: !isValid,
            options: {
                races: this.state.selectedRaces,
                results: {
                    country: this.state.resultCountry,
                    region: this.state.resultRegion,
                    group: this.state.resultGroup,
                    section: this.state.resultSection,
                    range: this.state.resultRange,
                },
                allCalculated: this.state.allCalculated,
                resultSize: this.state.resultSize === '' ? null : this.state.resultSize,
                onlyJuniorsBeginners: this.state.onlyJuniorsBeginners,
                onlySex: this.state.onlySex === '' ? null : this.state.onlySex,
                onlyYear: this.state.onlyYear === '' ? null : this.state.onlyYear,
                sectionsOrGroups: this.state.sectionsOrGroups === '' ? null : this.state.sectionsOrGroups,
                showPricesAndClasses: this.state.showPricesAndClasses,
                format: 'default',
            },
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceResults);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/RaceResults.js